var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMingcuteInviteLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_969_640)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 3C17.7652 2.99996 18.5015 3.29233 19.0583 3.81728C19.615 4.34224 19.9501 5.06011 19.995 5.824L20 6V10.35L20.594 10.086C21.208 9.813 21.916 10.236 21.994 10.884L22 11V19C22.0002 19.5046 21.8096 19.9906 21.4665 20.3605C21.1234 20.7305 20.6532 20.9572 20.15 20.995L20 21H4C3.49542 21.0002 3.00943 20.8096 2.63945 20.4665C2.26947 20.1234 2.04284 19.6532 2.005 19.15L2 19V11C2 10.328 2.675 9.853 3.297 10.045L3.407 10.086L4 10.35V6C3.99996 5.23479 4.29233 4.49849 4.81728 3.94174C5.34224 3.38499 6.06011 3.04989 6.824 3.005L7 3H17ZM20 12.539L12.812 15.733C12.5564 15.8466 12.2797 15.9053 12 15.9053C11.7203 15.9053 11.4436 15.8466 11.188 15.733L4 12.54V19H20V12.539ZM17 5H7C6.73478 5 6.48043 5.10536 6.29289 5.29289C6.10536 5.48043 6 5.73478 6 6V11.239L12 13.906L18 11.239V6C18 5.73478 17.8946 5.48043 17.7071 5.29289C17.5196 5.10536 17.2652 5 17 5ZM12 8C12.2549 8.00028 12.5 8.09788 12.6854 8.27285C12.8707 8.44782 12.9822 8.68695 12.9972 8.94139C13.0121 9.19584 12.9293 9.44638 12.7657 9.64183C12.6021 9.83729 12.3701 9.9629 12.117 9.993L12 10H10C9.74512 9.99972 9.49997 9.90212 9.31463 9.72715C9.1293 9.55218 9.01776 9.31305 9.00283 9.05861C8.98789 8.80416 9.07067 8.55362 9.23426 8.35817C9.39785 8.16271 9.6299 8.0371 9.883 8.007L10 8H12Z",
    className: "svgFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_969_640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteInviteLine);
export default __webpack_public_path__ + "static/media/mingcute_invite-line.2596d699.svg";
export { ForwardRef as ReactComponent };